import * as z from 'zod';
import { Data as Data$1 } from './bid-contract-surety-bond-form.types.mjs';
import * as bidContractSuretyBondForm_types from './bid-contract-surety-bond-form.types.mjs';
export { bidContractSuretyBondForm_types as Bid };
import { Data as Data$2 } from './final-contract-surety-bond-form.types.mjs';
import * as finalContractSuretyBondForm_types from './final-contract-surety-bond-form.types.mjs';
export { finalContractSuretyBondForm_types as Final };

var Data;
(function (Data) {
    Data.schema = z.discriminatedUnion("contractSuretyType", [
        Data$1.schema,
        Data$2.schema,
    ]);
})(Data || (Data = {}));

export { Data };
